import { Box, Flex, Text } from "@costar/theme-ui";
import React from "react";
import FlashIcon from "./icons";
export var SavedSearchNewPill = function (_a) {
    var newItemTag = _a.newItemTag, _b = _a.fontSizeToken, fontSizeToken = _b === void 0 ? "xxs" : _b, _c = _a.height, height = _c === void 0 ? "25px" : _c;
    return (React.createElement(Flex, { alignItems: "center", height: "28px" },
        React.createElement(Flex, { justifyContent: "center", alignItems: "center", color: "#ffffff", fontFamily: "Helvetica", fontWeight: "bold", letterSpacing: "0.63px", height: height, px: "10px", py: "10px", opacity: 0.85, borderRadius: "14px", backgroundColor: "#0559b3" },
            React.createElement(FlashIcon, { width: 6, height: 11 }),
            React.createElement(Box, { width: "100%" },
                React.createElement(Text, { ellipsis: true, fontFamily: "Helvetica", margin: "3px", fontSize: fontSizeToken }, newItemTag)))));
};
//# sourceMappingURL=SavedSearchNewPill.js.map